<template>
    <div class="sphere--btn">
        <button class="sphere--btn--button" :class="[color, {selected}]" @click.prevent="onClick()">
            <span class="sphere--btn--letter"><slot></slot></span>
            <span class="sphere--btn--label" :class="lineClass" v-html="label"></span>
        </button>
        <div class="sphere--btn--line" :class="lineClass"></div>
    </div>
</template>

<script>
export default {
    name:"SphereButton",
    props: {
        label: {
            type: String,
            default: ""
        },
        selected: {
            type:Boolean,
            default : false
        },
        data : {
        },
        color : {
            type : String,
            default : "red"
        },
        lineClass : {
            type : String,
            default : ""
        }
    },
    methods: {
        onClick() {
            this.$emit("click", this.data);
        }
    }
};
</script>

<style scoped lang="scss">
    $btnSize : 4.5rem;

    .sphere--btn {
        width : $btnSize;
        height : $btnSize;
        position: absolute;
        margin-left: math.div($btnSize, -2);
        margin-top: math.div($btnSize, -2);

        &--button {
            @extend .reset-btn;
            width : $btnSize;
            height : $btnSize;
            border-radius: math.div($btnSize, 2);
            background: white;
            box-shadow: 0px 9px 15px 1px rgba(0,0,0,0.27);
            border: solid white 4px;
            transition:background-color 350ms;

            &:hover {
                color : black;
            }

            &.selected {
                background : $color-red;

                .sphere--btn--letter {
                    color : white;
                }
                .sphere--btn--label {
                    color : black;
                }
            }

            &.green.selected {
                background : $color-green;
            }

            &.blue.selected {
                background : $color-blue;
            }

            &.yellow.selected {
                background : $color-yellow;
            }

            &.orange.selected {
                background : $color-orange;
            }
        }

        &--letter {
            color : #000000;
            font-weight: bold;
            font-size : 1.85rem;
            text-transform: uppercase;

            :deep(img) {
                width: 1.25em;
                display: inline-block;
                margin-top: .2em;
            }
        }

        &--label {
            font-size: 1.3rem;
            text-align: left;
            left: 8rem;
            position: absolute;
            top : 1.65rem;
            width: 15rem;

            &.top-small {
                left: 5.9rem;
                top: -1.4rem;
            }
            &.bottom-small {
                left: 5.9rem;
                top: 4.9rem;
            }
        }

        &--line {
            background-image: url('/img/sales-select/sphere-line.svg');
            background-repeat: no-repeat;
            background-position: center;
            width: 3rem;
            height: 1rem;
            display: block;
            position: absolute;
            right: -2.9rem;
            top: 1.8rem;
            z-index: -1;

            &.top-small {
                background-image: url('/img/sales-select/sphere-line-top-small.svg');
                width: 2.3rem;
                height: 2rem;
                right: -1rem;
                top: -1.2rem;
            }
            &.bottom-small {
                background-image: url('/img/sales-select/sphere-line-bottom-small.svg');
                width: 2.3rem;
                height: 2rem;
                right: -1rem;
                top: 4rem;
            }
        }

        &:first-child {
            .sphere--btn--line {
                background-image: url('/img/sales-select/sphere-line-top.svg');
                width : 8.15rem;
                height : 2rem;
                right: -6.8rem;
                top: -1.6rem;
            }

            .sphere--btn--label {
                left: 11.6rem;
                top: -2rem;
            }
        }

        &:last-child {
            .sphere--btn--line {
                background-image: url('/img/sales-select/sphere-line-bottom.svg');
                width : 8.15rem;
                height : 2rem;
                right: -6.7rem;
                top: 4.1rem;
            }

            .sphere--btn--label {
                left: 11.6rem;
                top: 5.2rem;
            }
        }

        @for $i from 1 through 10 {
            &:nth-child(#{$i}) {
                @include fadeIntro(350ms, #{500ms + $i * 250ms});
            }
        }

        .line {
             background-image: url('/img/sales-select/sphere-line.svg');
            background-repeat: no-repeat;
            background-position: center;
            width: 3rem;
            height: 1rem;
            display: block;
            position: absolute;
            right: -3.2rem;
            top: 1.6rem;
            z-index: -1;
        }

    }
</style>
